import { retrieveMatterStatusCategoriesV2 } from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveMatterStatusCategoriesQueryOptions = () => ({
  queryKey: [queryKeys.matterStatusCategories],
  queryFn: () => retrieveMatterStatusCategoriesV2(),
});
